import script from "./EditPropertyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPropertyModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditPropertyModal.vue?vue&type=style&index=0&id=2bd60420&lang=scss"

const __exports__ = script;

export default __exports__